import { activeCaseCode, activeUserId } from "./case-scoped-storage";

const OfflineQueueFormHook = {
  mounted() {
    this.handleSubmit = (event) => {
      if (navigator.onLine) return;

      const messageField = this.el.querySelector("[name='message']");
      const message = messageField?.value?.trim();
      if (!message) return;

      event.preventDefault();

      const threadId = this.el.dataset.offlineQueueThreadId;
      const groupId = this.el.dataset.offlineQueueGroupId;
      const priority = this.el.dataset.offlineQueuePriority;
      const caseCode = this.el.dataset.offlineQueueCaseCode || activeCaseCode();
      const userId = activeUserId();
      const label = `Send message${threadId ? " in thread" : ""}`;

      window.isxOfflineQueue.add({
        type: "chat_message",
        label,
        payload: { message },
        metadata: { threadId, groupId, priority, caseCode, userId },
        path: window.location.pathname,
        dedupeKey: `chat_message:${caseCode || "unknown"}:${userId || "unknown"}:${threadId || "unknown"}:${message}`,
      });

      messageField.value = "";
      messageField.dispatchEvent(new Event("input", { bubbles: true }));
    };

    this.el.addEventListener("submit", this.handleSubmit);

    window.isxOfflineQueue.registerProcessor("chat_message", (item) => {
      return new Promise((resolve, reject) => {
        if (!item || !item.payload?.message) {
          resolve();
          return;
        }

        const metadata = item.metadata || {};
        const currentThreadId = this.el.dataset.offlineQueueThreadId;
        const currentGroupId = this.el.dataset.offlineQueueGroupId;

        if (metadata.threadId && metadata.threadId !== currentThreadId) {
          reject(new Error("Queued message thread no longer matches the active form"));
          return;
        }

        if (metadata.groupId && metadata.groupId !== currentGroupId) {
          reject(new Error("Queued message group no longer matches the active form"));
          return;
        }

        let settled = false;
        const settle = (ok, reason) => {
          if (settled) return;
          settled = true;
          window.clearTimeout(timeout);
          if (ok) {
            resolve();
          } else {
            reject(reason || new Error("Queued message was not accepted"));
          }
        };

        const timeout = window.setTimeout(() => {
          settle(false, new Error("Queued message acknowledgment timed out"));
        }, 10000);

        try {
          this.pushEventTo(this.el, "send_message", {
            message: item.payload.message,
            thread_id: metadata.threadId,
            group_id: metadata.groupId,
            priority: metadata.priority,
          }, (reply) => {
            settle(reply?.ok === true, new Error(reply?.error || "Queued message was not accepted"));
          });
        } catch (error) {
          settle(false, error);
        }
      });
    });
  },
  destroyed() {
    this.el.removeEventListener("submit", this.handleSubmit);
  },
};

export default OfflineQueueFormHook;
